import { useCallback, useEffect, useState } from 'react';
import { readOmega3Selection, writeOmega3Selection } from '../utils/omega3ProductSuggestion';

const getStorage = () => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

const useOmega3Selection = (quizId, canSelect) => {
  const [selection, setSelection] = useState({ quizId: 0, isSelected: false, hasAdded: false });

  useEffect(() => {
    if (!quizId || canSelect === undefined) return;
    const restored = canSelect
      ? readOmega3Selection(getStorage(), quizId)
      : { isSelected: false, hasAdded: false };
    setSelection({ quizId, ...restored });
    if (!canSelect) writeOmega3Selection(getStorage(), quizId, restored);
  }, [quizId, canSelect]);

  const handleChange = useCallback(
    (isSelected) => {
      if (!quizId || !canSelect) return;
      setSelection((current) => {
        const next = {
          quizId,
          isSelected,
          hasAdded: isSelected || (current.quizId === quizId && current.hasAdded),
        };
        writeOmega3Selection(getStorage(), quizId, next);
        return next;
      });
    },
    [quizId, canSelect],
  );

  const isCurrent = Boolean(canSelect && selection.quizId === quizId);
  return {
    isReady: selection.quizId === quizId && canSelect !== undefined,
    isSelected: isCurrent && selection.isSelected,
    hasAdded: isCurrent && selection.hasAdded,
    handleChange,
  };
};

export default useOmega3Selection;
